import { Serializable } from "@/core/api/decorators/serializable_decorator"
import { WorkArrangement } from "../../active/constants/workArrangement"
import {
  ArrayNotEmpty,
  IsNotEmpty,
  IsPositive,
  IsString,
  Validate,
  ValidateIf,
  ValidationArguments,
  ValidatorConstraint,
  ValidatorConstraintInterface,
} from "class-validator"

@ValidatorConstraint({ name: "dsvHiringLocationAddresses", async: false })
class DsvHiringLocationAddressesConstraint
  implements ValidatorConstraintInterface
{
  validate(
    addresses: HiringLocation["addresses"] | undefined,
    args: ValidationArguments,
  ): boolean {
    const o = args.object as HiringLocation
    if (this.skipAddresses(o)) return true
    if (!Array.isArray(addresses)) return false
    return addresses.some((a) => typeof a === "string" && a.trim() !== "")
  }

  defaultMessage(): string {
    return "common:form.errors.empty"
  }

  private skipAddresses(o: HiringLocation): boolean {
    if (o.isRemoteWork === true) return true
    const raw = o.workArrangement as unknown
    if (raw === WorkArrangement.Remote || raw === 3 || raw === "3") return true
    const n = Number(raw)
    return !Number.isNaN(n) && n === WorkArrangement.Remote
  }
}

@Serializable
export class HiringLocation {
  @IsNotEmpty({
    message: "common:form.errors.empty",
    groups: ["hiring_locations", "dsv", "candidate_location"],
  })
  mainTaskId: string = "" // Used for the country selector.
  @IsNotEmpty({
    message: "common:form.errors.empty",
    groups: ["hiring_locations", "dsv", "candidate_location"],
  })
  mainTaskName: string = ""

  isRemoteWork: boolean = false
  @ValidateIf(
    (obj: HiringLocation) =>
      obj.workArrangement === WorkArrangement.Office ||
      obj.workArrangement === WorkArrangement.Hybrid,
    {
      groups: ["hiring_locations"],
    },
  )
  @IsNotEmpty({
    message: "common:form.errors.empty",
    groups: ["hiring_locations", "seven_n_details"],
  })
  city: string = ""
  // @IsNotEmpty({
  //   message: "common:form.errors.empty",
  // })
  countryName: string = "Other"
  countryCode: string = ""
  currency: string = "EUR"
  @IsPositive({
    message: "common:form.errors.empty",
    groups: [
      "hiring_locations",
      "edit_tryg_locations",
      "candidate_location",
      "seven_n_details",
    ],
  })
  workArrangement: WorkArrangement = WorkArrangement.NotDefined
  @IsPositive({
    message: '$t(common:form.errors.greater_or_equal, {"count": 0 })',
    groups: ["time_and_material", "edit_tryg_locations"],
  })
  numHoursWeek: number = null
  @ValidateIf(
    (obj: HiringLocation) => obj.workArrangement === WorkArrangement.Hybrid,
    {
      groups: ["hiring_locations", "edit_tryg_locations"],
    },
  )
  @IsPositive({
    message: '$t(common:form.errors.greater_or_equal, {"count": 0 })',
    groups: ["hiring_locations", "edit_tryg_locations"],
  })
  numDaysInOffice: number = null
  @Validate(DsvHiringLocationAddressesConstraint, {
    message: "common:form.errors.empty",
    groups: ["dsv"],
  })
  @ValidateIf(
    (obj: HiringLocation) =>
      obj.workArrangement === WorkArrangement.Office ||
      obj.workArrangement === WorkArrangement.Hybrid,
    {
      groups: ["hiring_locations"],
    },
  )
  @ArrayNotEmpty({
    message: "common:form.errors.empty",
    groups: ["hiring_locations"],
  })
  @IsString({
    message: "common:form.errors.empty",
    groups: ["hiring_locations"],
    each: true,
  })
  addresses: string[] = []

  constructor(init?: Partial<HiringLocation>) {
    Object.assign(this, init)
  }
}
